import axios from 'axios';

// Client token for API authentication
// This is a frontend client token that identifies this application to the backend
const CLIENT_TOKEN = 'cnxn_admin_token';

// Create an axios instance with default config
// Authorization tokens are injected by interceptors in authService.js
const apiClient = axios.create({
  baseURL: '/api', // The server.js is configured to serve API at /api
  headers: {
    'Content-Type': 'application/json',
    'x-client-token': CLIENT_TOKEN // Add client token to all requests
  }
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log API errors
    console.error('API Error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient;